export const landingTrackerText = ({
    tipo_prodotto = '', tipo_fornitura = '', tipo_contratto = '',
    sv20 = '', sv21 = '', sv22 = '',
    productId = '', productName = ''
}) => (
        `adf.Params.PageName = encodeURIComponent('vivigas|x|funnel|landing'); ` +
        `adf.Params.Divider = encodeURIComponent('|');` +
        `adf.createOrder({  ` +
        `    sv1: '${tipo_prodotto}',` +
        `    sv2: '${tipo_fornitura}',` +
        `    sv3: '${tipo_contratto}',` +
        `    sv20: '${sv20}',` +
        `    sv21: '${sv21}',` +
        `    sv22: '${sv22}'` +
        `});` +
        `adf.addProduct({ ` +
        `    productid: '${productId}',` +
        `    productname: '${productName}'` +
        `    ` +
        `});` +
        `adf.track(1495908);`)

export const setTrackerScript = ({
    trackName = '',
    sv1 = '', sv2 = '', sv3 = '',
    sv20 = '', sv21 = '', sv22 = '',
    productId = '', productName = '',
    customObjectTracking = {}
}) => {
    if (window.adf) {
        const adf = window.adf;
        adf.Params.PageName = encodeURIComponent(trackName);
        adf.Params.Divider = encodeURIComponent('|');
        adf.createOrder({
            sv1,
            sv2,
            sv3,
            sv20,
            sv21,
            sv22,
            ...customObjectTracking
        });
        adf.addProduct({
            productid: productId,
            productname: productName
        });
        adf.track(1495908);
    } else {
        console.log('ADF: tracking page not defined');
    }
}